module.exports = __webpack_public_path__ + "static/media/featureimage2.f5c78fbf.jpg";